import { createSlice } from '@reduxjs/toolkit'

const officeSlice = createSlice({
    name: 'office',
    initialState: { off: null },
    reducers: {
        setOff: (state, action) => {
            state.off = action.payload
        },  
    }
})

export const { setOff } = officeSlice.actions

export default officeSlice.reducer

// export const selectCurrentOffice = (state) => state.office.off